import { render } from "./play-button.vue?vue&type=template&id=3d77ec46"
import script from "./play-button.vue?vue&type=script&lang=js"
export * from "./play-button.vue?vue&type=script&lang=js"

import "./play-button.vue?vue&type=style&index=0&id=3d77ec46&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__